var _excluded = ["isReadOnly", "isViewMode", "value", "isLoading", "onChange", "onViewModeClick", "acceptTypes", "deleteButtonText", "fileAltText", "overrideFileName", "width"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useRef, useState } from 'react';
import { Icon } from '../../../foundations';
import { forwardRef, useBoolean, useHasOverflowY } from '../../../utils';
import { getInputFileAcceptByType } from '../../../utils/get-input-file-accept';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { NakedButton } from '../../action';
import { Tooltip } from '../../dataDisplay';
import { Blanket } from '../../feedback';
import { Box, ConditionalWrapper } from '../../internal';
import { IFrame } from '../../internal/IFrame';
import { Image } from '../../media';
import { FileAttachmentEmpty } from './assets/FileAttachmentEmpty';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FileAttachment = forwardRef((_ref, ref) => {
  var _ref2, _ref3;

  var {
    isReadOnly,
    isViewMode,
    value,
    isLoading,
    onChange,
    onViewModeClick,
    acceptTypes,
    deleteButtonText,
    fileAltText,
    overrideFileName,
    width = 176
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var hiddenFileInputRef = useRef(null);
  var isEmpty = !value;
  var [isHover, setIsHover] = useBoolean(false);
  var [file, setFile] = useState();
  var [noPreview, setNoPreview] = useState();
  var noPreviewFileName = (_ref2 = (_ref3 = overrideFileName !== null && overrideFileName !== void 0 ? overrideFileName : fileAltText) !== null && _ref3 !== void 0 ? _ref3 : value) !== null && _ref2 !== void 0 ? _ref2 : file === null || file === void 0 ? void 0 : file.name;
  var noPreviewFileNameRef = useRef(null);
  var hasOverflow = useHasOverflowY({
    ref: noPreviewFileNameRef
  });
  var isEditState = !isReadOnly && !isViewMode;
  var showFileAttachmentEmpty = isEmpty;
  var showImage = !isEmpty && !noPreview;
  var showImageMask = isEditState;
  var showLoader = isLoading;
  var showDeleteButton = isEditState && value;
  var isViewModeReadOnly = isViewMode && !onViewModeClick && !isEmpty || isReadOnly;
  var showAttachmentIcon = !isEmpty && !isEditState && !isLoading;
  var showEditIcon = isEditState && !isLoading;
  var showIcon = showAttachmentIcon || showEditIcon;
  var isClickable = !isReadOnly && (!isViewMode || !isEmpty || isViewMode && onViewModeClick) && !isLoading;

  var handleClick = () => {
    var _hiddenFileInputRef$c;

    if (!isClickable) return;

    if (isViewMode && value) {
      onViewModeClick === null || onViewModeClick === void 0 ? void 0 : onViewModeClick(value);
      return;
    }

    (_hiddenFileInputRef$c = hiddenFileInputRef.current) === null || _hiddenFileInputRef$c === void 0 ? void 0 : _hiddenFileInputRef$c.click();
  };

  var handleChange = _ref4 => {
    var {
      target: {
        files
      }
    } = _ref4;

    if (files !== null && files !== void 0 && files[0]) {
      setNoPreview(false);
      setFile(files[0]);
      var fileUrl = URL.createObjectURL(files[0]);
      onChange === null || onChange === void 0 ? void 0 : onChange(fileUrl, files[0]);
    }
  };

  var handleDelete = event => {
    event.stopPropagation(); // clear input so same file can be chosen again (if user wants)

    if (hiddenFileInputRef.current) {
      hiddenFileInputRef.current.value = '';
    }

    onChange === null || onChange === void 0 ? void 0 : onChange(null);
  };

  var styles = useMultiStyleConfig('FileAttachment', {
    isEmpty,
    onViewModeClick,
    width
  });
  return /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
    "data-component": "FileAttachment"
  }, props), {}, {
    ref: ref,
    __css: styles['container'],
    onMouseOver: setIsHover.on,
    onMouseOut: setIsHover.off,
    children: [/*#__PURE__*/_jsxs(Box, {
      as: "button",
      "data-testid": "file-image-container",
      "aria-label": "file attachment",
      "data-view-mode": isViewMode || null,
      "data-readonly": isViewModeReadOnly || null,
      "data-loading": isLoading || null,
      __css: styles['fileImageContainer'],
      tabIndex: isClickable ? 0 : -1,
      onClick: handleClick,
      children: [showIcon && /*#__PURE__*/_jsx(Box, {
        __css: styles['attachmentIconContainer'],
        "data-view-mode": isViewMode || null,
        "data-readonly": isReadOnly || null,
        "data-hover": isHover || null,
        children: /*#__PURE__*/_jsx(Icon, {
          type: isViewMode || isReadOnly ? 'attachment' : 'image-add',
          color: "inverted",
          "aria-label": "Add Image",
          size: isViewMode || isReadOnly ? 'small' : 'large',
          "data-hover": isHover || null
        })
      }), showFileAttachmentEmpty && /*#__PURE__*/_jsx(FileAttachmentEmpty, {}), showImage && (file !== null && file !== void 0 && file.type.includes('pdf') ? /*#__PURE__*/_jsx(IFrame, {
        title: fileAltText !== null && fileAltText !== void 0 ? fileAltText : file.name,
        __css: styles['pdf'],
        src: value
      }) : /*#__PURE__*/_jsx(Image, {
        alt: fileAltText !== null && fileAltText !== void 0 ? fileAltText : value,
        src: value,
        onError: () => setNoPreview(true),
        width: "inherit"
      })), noPreview && value && /*#__PURE__*/_jsx(ConditionalWrapper, {
        condition: hasOverflow,
        wrapper: children => /*#__PURE__*/_jsx(Tooltip, {
          label: noPreviewFileName,
          children: children
        }),
        children: /*#__PURE__*/_jsx(Box, {
          as: "span",
          __css: styles['noPreview'],
          ref: noPreviewFileNameRef,
          children: noPreviewFileName
        })
      }), /*#__PURE__*/_jsx(Blanket, {
        isOpen: showImageMask,
        isLoading: showLoader
      }), /*#__PURE__*/_jsx(Box, {
        as: "input" // ts-ignore is used due to `type` issues with `<Box/>`.
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        ,
        type: "file",
        "aria-label": "upload file",
        "data-testid": "upload-file-input",
        accept: getInputFileAcceptByType(acceptTypes),
        ref: hiddenFileInputRef,
        style: {
          display: 'none'
        },
        onChange: handleChange
      })]
    }), showDeleteButton && /*#__PURE__*/_jsx(Box, {
      __css: styles['deleteButton'],
      children: /*#__PURE__*/_jsx(NakedButton, {
        "data-testid": "delete-file",
        isDisabled: isLoading,
        variant: "critical",
        onClick: handleDelete,
        label: deleteButtonText !== null && deleteButtonText !== void 0 ? deleteButtonText : 'Delete File'
      })
    })]
  }));
});
FileAttachment.displayName = 'FileAttachment';
//# sourceMappingURL=FileAttachment.js.map